"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SchedulerAvailability = void 0;
var SchedulerAvailability;
(function (SchedulerAvailability) {
    SchedulerAvailability["OPEN"] = "OPEN";
    SchedulerAvailability["CUSTOM"] = "CUSTOM";
    SchedulerAvailability["ROLLING"] = "ROLLING";
    SchedulerAvailability["RANGE"] = "RANGE";
})(SchedulerAvailability = exports.SchedulerAvailability || (exports.SchedulerAvailability = {}));
